export const pageTranslations = {
  en: {
    description: "Description",
    specialOffer: "OUR SPECIAL OFFER INCLUDED IN THE PRICE",
    readMore: "Read More...",
    extraServicesTitle: "FOR EXTRA SERVICES AND REQUESTS NOT INCLUDED IN THE PRICE",
    featuresTitle: "The Features of {yachtName}", // {yachtName} will be replaced dynamically
    featureLabels: {
      yachtName: "Yacht Name:",
      yachtType: "Yacht Type:",
      brand: "Brand:",
      capacity: "Capacity:",
      crew: "Crew:",
      cabin: "Cabin:",
      showerWC: "Shower/WC:",
      length: "Length:",
      width: "Width:",
      speed: "Speed:",
      manufacturing: "Manufacturing:",
      refitDate: "Refit Date:",
      location: "Location:",
      distance: "Distance:"
    },
    equipmentTitle: "The Equipment of {yachtName}", // {yachtName} will be replaced dynamically
    includedInPrice: "Included in Price",
    availableExtras: "Available Extras",
    overview: "Overview",
    quickDetails: "Quick Details",
    capacity: "Capacity",
    cabins: "Cabins",
    breaks: "Breaks",
    technicalSpecifications: "Technical Specifications",
    length: "Length",
    builder: "Builder",
    equipment: "Equipment",
    optionalServices: "Optional Services",
    cancellationPolicy: "Cancellation Policy",
    fullRefund: "Full Refund:",
    partialRefund: "Partial Refund:",
    noRefund: "No Refund:",
    bookThisYacht: "Book This Yacht",
    bookingDescription: "Experience luxury at sea with our premium yacht service",
    bookNow: "Book Now"
  },
  tr: {
    description: "Açıklama",
    specialOffer: "FİYATA DAHİL ÖZEL TEKLİFİMİZ",
    readMore: "Daha Fazla Oku...",
    extraServicesTitle: "FİYATA DAHİL OLMAYAN EKSTRA HİZMETLER VE TALEPLER İÇİN",
    featuresTitle: "{yachtName} Özellikleri",
    featureLabels: {
      yachtName: "Yat Adı:",
      yachtType: "Yat Türü:",
      brand: "Marka:",
      capacity: "Kapasite:",
      crew: "Mürettebat:",
      cabin: "Kabin:",
      showerWC: "Duş/WC:",
      length: "Uzunluk:",
      width: "Genişlik:",
      speed: "Hız:",
      manufacturing: "Üretim:",
      refitDate: "Yenileme Tarihi:",
      location: "Konum:",
      distance: "Mesafe:"
    },
    equipmentTitle: "{yachtName} Donanımı",
    includedInPrice: "Fiyata Dahil",
    availableExtras: "Mevcut Ekstralar",
    overview: "Genel Bakış",
    quickDetails: "Hızlı Detaylar",
    capacity: "Kapasite",
    cabins: "Kabinler",
    breaks: "Molalar",
    technicalSpecifications: "Teknik Özellikler",
    length: "Uzunluk",
    builder: "İnşa Eden",
    equipment: "Donanım",
    optionalServices: "Opsiyonel Hizmetler",
    cancellationPolicy: "İptal Politikası",
    fullRefund: "Tam İade:",
    partialRefund: "Kısmi İade:",
    noRefund: "İade Yok:",
    bookThisYacht: "Bu Yatı Rezerve Et",
    bookingDescription: "Premium yat servisimizle denizde lüksü yaşayın",
    bookNow: "Şimdi Rezerve Et"
  },
  de: {
    description: "Beschreibung",
    specialOffer: "UNSER SPEZIALANGEBOT IM PREIS ENTHALTEN",
    readMore: "Mehr Lesen...",
    extraServicesTitle: "FÜR ZUSÄTZLICHE DIENSTE UND ANFRAGEN, DIE NICHT IM PREIS ENTHALTEN SIND",
    featuresTitle: "Die Eigenschaften von {yachtName}",
    featureLabels: {
      yachtName: "Yachtname:",
      yachtType: "Yachttyp:",
      brand: "Marke:",
      capacity: "Kapazität:",
      crew: "Crew:",
      cabin: "Kabine:",
      showerWC: "Dusche/WC:",
      length: "Länge:",
      width: "Breite:",
      speed: "Geschwindigkeit:",
      manufacturing: "Herstellung:",
      refitDate: "Renovierungsdatum:",
      location: "Standort:",
      distance: "Entfernung:"
    },
    equipmentTitle: "Die Ausstattung von {yachtName}",
    includedInPrice: "Im Preis enthalten",
    availableExtras: "Verfügbare Extras",
    overview: "Übersicht",
    quickDetails: "Kurzdetails",
    capacity: "Kapazität",
    cabins: "Kabinen",
    breaks: "Pausen",
    technicalSpecifications: "Technische Spezifikationen",
    length: "Länge",
    builder: "Bauunternehmen",
    equipment: "Ausstattung",
    optionalServices: "Optionale Dienstleistungen",
    cancellationPolicy: "Stornierungsrichtlinie",
    fullRefund: "Volle Rückerstattung:",
    partialRefund: "Teilweise Rückerstattung:",
    noRefund: "Keine Rückerstattung:",
    bookThisYacht: "Diese Yacht buchen",
    bookingDescription: "Erleben Sie Luxus auf See mit unserem Premium-Yachtservice",
    bookNow: "Jetzt buchen"
  },
  ru: {
    description: "Описание",
    specialOffer: "НАШЕ СПЕЦИАЛЬНОЕ ПРЕДЛОЖЕНИЕ, ВКЛЮЧЕННОЕ В СТОИМОСТЬ",
    readMore: "Читать далее...",
    extraServicesTitle: "ДЛЯ ДОПОЛНИТЕЛЬНЫХ УСЛУГ И ЗАПРОСОВ, НЕ ВКЛЮЧЕННЫХ В СТОИМОСТЬ",
    featuresTitle: "Характеристики {yachtName}",
    featureLabels: {
      yachtName: "Название яхты:",
      yachtType: "Тип яхты:",
      brand: "Бренд:",
      capacity: "Вместимость:",
      crew: "Экипаж:",
      cabin: "Каюта:",
      showerWC: "Душ/туалет:",
      length: "Длина:",
      width: "Ширина:",
      speed: "Скорость:",
      manufacturing: "Производство:",
      refitDate: "Дата ремонта:",
      location: "Местоположение:",
      distance: "Расстояние:"
    },
    equipmentTitle: "Оборудование {yachtName}",
    includedInPrice: "Включено в стоимость",
    availableExtras: "Доступные дополнения",
    overview: "Обзор",
    quickDetails: "Краткие сведения",
    capacity: "Вместимость",
    cabins: "Каюты",
    breaks: "Остановки",
    technicalSpecifications: "Технические характеристики",
    length: "Длина",
    builder: "Строитель",
    equipment: "Оборудование",
    optionalServices: "Дополнительные услуги",
    cancellationPolicy: "Политика отмены",
    fullRefund: "Полный возврат:",
    partialRefund: "Частичный возврат:",
    noRefund: "Без возврата:",
    bookThisYacht: "Забронировать эту яхту",
    bookingDescription: "Ощутите роскошь на море с нашим премиум-сервисом яхт",
    bookNow: "Забронировать сейчас"
  }
};